import React, { Component } from 'react';

import api from '../../../../api/';
import ParadigmaTable from "../../../../components/ParadigmaTable/";
import ItemOrderUpdateModal from '../../../../components/ItemOrderUpdateModal/ItemOrderUpdateModal'
import ShowItemBtn from '../../../../components/ShowItemBtn/ShowItemBtn';

class Lineas extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    show: false,
                    private: true,
                },
              {
                  Header: "Codigo",
                  id: "Codigo",
                  accessor: "Codigo",
                  show: true,
                  width: 150,
              },
              {
                  Header: "Nombre",
                  id: "Nombre",
                  accessor: d => d.Nombre,
                  show: true,
              },
              {
                Header: "Visible",
                id: "Show",
                accessor: d => d.Show ? "SI" : "NO",
                show: true,
                filterable: true,
                lookup: "exact",
                Filter: ({ filter, onChange }) => (
                    <select
                        onChange={event => onChange(event.target.value)}
                        style={{ width: "100%" }}
                        value={filter ? filter.value : ""}>
                        <option value="">TODOS</option>
                        <option value={"True"}>SI</option>
                        <option value={"False"}>NO</option>
                    </select>
                ),
                width: 100,
                className: "text-center",
              },
              {
                  Header: "De Baja",
                  id: "DeBaja",
                  accessor: d => d.DeBaja ? "SI" : "NO",
                  show: true,
                  filterable: true,
                  lookup:"exact",
                  Filter: ({ filter, onChange }) =>(
                       <select
                       onChange={event => onChange(event.target.value)}
                       style={{ width: "100%" }}
                       value={filter ? filter.value : ""}>
                       <option value="">TODOS</option>
                       <option value={"True"}>SI</option>
                       <option value={"False"}>NO</option>
                       </select>
                  ),
                  width: 100,
                  className:"text-center",
              },
            ]
        };
    }

    render() {
        const { modernTheme } = this.props;
        const propsShowItemBtn = {
            label: 'Línea',
            labelMany: 'Líneas',
            submitUrl: api.gestion.articulos.lineasMostrarOcultar,
            femaleLabel:true
        }
        return (
            <ParadigmaTable
                modernTheme={modernTheme}
                buttons={[
                    {
                        permission: "ecommerce_articulos_articulos_edit",
                        customComponent: true,
                        multiSelect: true,
                        component: (props) => (<ShowItemBtn {...props} {...propsShowItemBtn} action="MOSTRAR" />),
                    },
                    {
                        permission: "ecommerce_articulos_articulos_edit",
                        customComponent: true,
                        multiSelect: true,
                        component: (props) => (<ShowItemBtn {...props} {...propsShowItemBtn} action="OCULTAR" />),
                    },
                    {
                        detail: true,
                        component: () => <ItemOrderUpdateModal {...{
                            url: api.gestion.articulos.lineas,
                            type: "Lineas",
                            nameField: "Nombre",
                            pkField: "Codigo",
                            orderField: "Order"
                        }} />,
                        permission: "ecommerce_articulos_articulos_edit",
                    },
                ]}
                outerFilter={[{id:"DeBaja", lookup:"exact", value:"False"}]}
                apiUrl={api.gestion.articulos.lineas}
                columns={this.state.columns}
                title={"Lineas"}
                multiSelect={true}
                ctrlKeyMultiSelect={true}
            />
        );
    }
}

export default Lineas;



// WEBPACK FOOTER //
// ./src/views/Gestion/Articulos/Lineas/Lineas.js